import type { OnChangeValue } from '@ksyos/design-system';
import type { ReactNode } from 'react';
import type { PropsValue } from 'react-select';
import { Select } from '@ksyos/design-system';
import { getEnumSelectOptions } from '../../utils/getEnumSelectOptions';

type EnumSelectProps<EnumType extends Record<string, string>, IsMulti extends boolean> = {
    enumObj: EnumType;
    id?: string;
    isClearable?: boolean;
    isMulti?: IsMulti;
    labels: Record<keyof EnumType, string>;
    onChange: (value: OnChangeValue<{ label: string; value: keyof EnumType }, IsMulti>) => void;
    placeholder?: ReactNode;
    size?: 'medium' | 'large';
    value?: PropsValue<keyof EnumType>;
};

export function EnumSelect<EnumType extends Record<string, string>, IsMulti extends boolean = false>({
    enumObj,
    isClearable,
    isMulti,
    labels,
    onChange,
    placeholder,
    id,
    value,
    size,
}: Readonly<EnumSelectProps<EnumType, IsMulti>>) {
    const options: { label: string; value: keyof EnumType }[] = getEnumSelectOptions(enumObj, labels);

    return (
        <Select
            id={id}
            isClearable={isClearable}
            isMulti={isMulti}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            size={size}
            value={
                Array.isArray(value)
                    ? options.filter((option) => value.includes(option.value))
                    : (options.find((option) => option.value === value) ?? null)
            }
        />
    );
}
